import { IHttpResponse } from './BackendService';
import { getAuth, postAuth } from './AuthHttpService';
import { IDataBundle } from '../interfaces/data-bundle.interface';
import { IDevProfile } from '../interfaces/dev-profile';
import { IUser } from '../interfaces/user';
import { DEV_PORTAL_API_URL } from '../app-config';

export const postDevProfile = async (
  hatName: string,
  data: IDevProfile,
): Promise<IHttpResponse<IDataBundle<IDevProfile>>> =>
  postAuth<IDataBundle<IDevProfile>>(`https://${hatName}/api/v2.6/data/developers/profile`, data);

export const getDevProfile = async (
  hatName: string,
): Promise<IHttpResponse<IDataBundle<IDevProfile>[]>> =>
  getAuth<IDataBundle<IDevProfile>[]>(
    `https://${hatName}/api/v2.6/data/developers/profile?take=1&orderBy=dateCreated&ordering=descending`,
  );

export const getUser = async (): Promise<IHttpResponse<IUser>> =>
  getAuth<IUser>(`${DEV_PORTAL_API_URL}/api/user`);
